import { Typography } from '@mui/material'

export const CardTitle = ({ children }: { children: string }): JSX.Element => (
  <Typography variant='h4' sx={{ fontWeight: 600, lineHeight: '32px' }}>{children}</Typography>
)
